import { Collapse, Offcanvas } from 'bootstrap'

let productChoice = [];
function initializeProductSelector() {
  let selectorControl = document.querySelector('.product-selector');

  if (selectorControl !== null) {

    initializeChoiceArray(selectorControl.dataset.group);
    initializeProductArray();
    initializeQuestionBlocks();

    let resetButton = document.querySelector('#btnReset');
    resetButton.addEventListener('click', function (e) {
      resetProductSelector();
    });

    document.querySelectorAll('input.question-button[type=radio]').forEach(button => {
      button.addEventListener('click', function (e) {
        checkButtonClicks(e.target);
        addPurpose2array(e.target);
      });
    });
  }

}

// Gets the Product Mapping from Web Api
function initializeChoiceArray(id) {
  $.ajax({
    url: `/webapi/productselectorapi/choices/${id}`,
    method: 'GET',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (response) {
      localStorage.setItem('productMapping', JSON.stringify(response.productMapping));
      console.log('Product Mapping Loaded');
    },
    error: function (errorMsg) {
      console.log(errorMsg);
    }
  })
}

// Gets the List of Products from Web Api
function initializeProductArray() {
  $.ajax({
    url: '/webapi/productselectorapi/products',
    method: 'GET',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (response) {
      localStorage.setItem('products', JSON.stringify(response.products))
      console.log('Products Loaded');
    },
    error: function (errorMsg) {
      console.log(errorMsg);
    }
  })
}

// Fetch data from local storage and parse it
function getProducts() {
  return JSON.parse(localStorage.getItem('products'));
}

function getProductMapping() {
  return JSON.parse(localStorage.getItem('productMapping'));
}

function checkButtonClicks(t) {
  let parentId = t.dataset.parentid;

  // Reduce productChoice array if a prior question option was clicked
  if (productChoice.length > parseInt(parentId)) {
    productChoice.length = parseInt(parentId);
  }

  // Show all options if prior option was clicked
  document.querySelectorAll('.col-md-6.option').forEach((e) => {
    if (e.dataset.questionid !== parentId || parseInt(e.dataset.questionid) > parseInt(parentId)) {
      if (e.classList.contains('d-none')) {
        e.classList.remove('d-none');
      }
    }
  })

  document.querySelectorAll('input.question-button[type=radio]').forEach(button => {
    if (button.dataset.parentid === parentId) {
      if (t.dataset.id !== button.dataset.id) {
        button.checked = false;
      }
    }
  })
}

function initializeQuestionBlocks() {
  document.querySelectorAll('.question-section').forEach(e => {
    if (e.dataset.order == 1) {
      if (e.classList.contains('d-none')) {
        e.classList.remove('d-none');
      }
    }
    else {
      if (!e.classList.contains('d-none')) {
        e.classList.add('d-none');
      }
    }
  });
}

// Resets questions and option blocks after clicking Reset Button
function resetProductSelector() {
  productChoice.length = 0;
  initializeQuestionBlocks();

  document.querySelectorAll('input.question-button[type=radio]').forEach(button => {
    button.checked = false;
  });


  document.querySelectorAll('.col-md-6.option').forEach((e) => {
    if (e.classList.contains('d-none')) {
      e.classList.remove('d-none');
    }
  })

  if (!document.getElementById('no-result').classList.contains('d-none')) {
    document.getElementById('result').classList.add('d-none');
  }

  if (!document.getElementById('result').classList.contains('d-none')) {
    document.getElementById('result').classList.add('d-none');
  }

  if (!document.getElementById('related').classList.contains('d-none')) {
    document.getElementById('related').classList.add('d-none');
  }

  
  $('.question-block').slideDown(1e3, function () { })
  
}

// Adds options to array
function addPurpose2array(t) {
  let questionId = t.dataset.parentid;
  let index = (questionId - 1);

  productChoice.splice(index, 1, t.value);

  if (parseInt(questionId) == (document.querySelectorAll('.question-section').length)) {
    showResult(t);
  }
  else {
    validateQuestions(index, (parseInt(questionId) + 1));
    validateBlocks(questionId);
  }
}

// Validates the options to show on the next question
function validateQuestions(index, val) {
  const result = [];
  let options = [];
  let optionResults = [];
  let productMapping = getProductMapping();
  let productString = productChoice.join(',');
  const optionButtons = document.querySelectorAll(`.col-md-6.option[data-questionid="${val}"]`);
  options = productMapping.map(function (a) {
    return a.criteriaId;
  });
  optionResults = options.filter(arrayElem => arrayElem.startsWith(productString));
  
  optionResults.map(i => i.split(',')).forEach((elem) => {
    result.push(elem[index + 1]);
  });

  optionButtons.forEach((e) => {
    if (!result.includes(e.dataset.optionid)) {
      e.classList.add('d-none');
    }
  })

}

// Shows the following block 
function validateBlocks(questionId) {
  let blocks = document.querySelectorAll('.question-section');

  blocks.forEach(e => {
    if (parseInt(e.dataset.order) == (parseInt(questionId) + 1)) {
      e.classList.remove('d-none');
    }
  })


}

function showResult() {
  let products = getProducts();
  let productMapping = getProductMapping();
  $('.question-block').slideUp(1e3, function () { })

  let e = productMapping.find((t) => t.criteriaId == productChoice);

  if (e === undefined || e == null) {
    if (document.getElementById('no-result').classList.contains('d-none')) {
      document.getElementById('no-result').classList.remove('d-none');
    }
    
  }
  else {
    // Send an event to Google Analytics for each selected answer
    document.querySelectorAll('.product-selector .questions input[type=radio]:checked').forEach(function (chk) {
      let question = chk.closest('.questions').previousElementSibling.textContent;
      let answer = chk.nextElementSibling.querySelector('span').textContent;

      dataLayer.push(
        {
          'event': 'prod_sel_questions',
          'event_category': 'ProductSelector',
          'event_label': `${window.location.pathname}, ${question}, ${answer}`
        });

    });

    let o = products.find((t) => t.productId == e.product),
      i = products.find((t) => t.productId == e.aditionalResults[0]),
      n = products.find((t) => t.productId == e.aditionalResults[1]);

    (document.getElementById('ProductTitle').innerHTML = `${o.name}`),
      (document.getElementById('amt').innerHTML = `${o.amount}`),
      (document.getElementById('avail').innerHTML = `${o.availability}`),
      (document.getElementById('ProductIntro').innerHTML = `${o.intro}`),
      (document.getElementById('ProductHtml').innerHTML = `${o.html}`),
      (document.getElementById('moreInfo').innerHTML = `<a class="btn btn-primary" onclick="dataLayer.push({'event': 'prod_sel_learn_more','event_category':'ProductSelector','event_label':'${o.name}'});" href="https://${o.moreInfo}">Find out more</a>`);

    if (document.getElementById('result').classList.contains('d-none')) {
      document.getElementById('result').classList.remove('d-none');
    }

    (document.getElementById('relProductTitle1').innerHTML = `${i.name}`),
      (document.getElementById('relProductIntro1').innerHTML = `${i.alsoIntro}`),
      (document.getElementById('relmoreInfo1').innerHTML = `<a class="btn btn-primary" onclick="dataLayer.push({'event': 'prod_sel_learn_more','event_category':'ProductSelector','event_label':'${i.name}'});" href="https://${i.moreInfo}">Find out more</a>`),
      (document.getElementById('relProductTitle2').innerHTML = `${n.name}`),
      (document.getElementById('relProductIntro2').innerHTML = `${n.alsoIntro}`),
      (document.getElementById('relmoreInfo2'
    ).innerHTML = `<a class="btn btn-primary" onclick="dataLayer.push({'event': 'prod_sel_learn_more','event_category':'ProductSelector','event_label':'${n.name}'});" href="https://${n.moreInfo}">Find out more</a>`);

    if (document.getElementById('related').classList.contains('d-none')) {
      document.getElementById('related').classList.remove('d-none');
    }

    if (document.getElementById('rating').classList.contains('d-none')) {
      document.getElementById('rating').classList.remove('d-none');
    }
  }  
}

document.addEventListener('DOMContentLoaded', () => {
  initializeProductSelector();
})
